export function formatDate(dateString) {
  var parts = dateString.split("/");

  var formattedDate = parts[1] + "/" + parts[0] + "/" + parts[2];

  return formattedDate;
}
